<template>
  <div>

    <div class="sign-box" v-show="isSignaturePadVisible">
      <div class="sign-content">
        <div class="title-box">
          <p class="cancel-p" @click="$emit('closePopup', true)">取消</p>
          <h1>手写签名</h1>
          <p class="confirm-p" @click="save">确定</p>
        </div>
        <VueSignaturePad v-if="isSignaturePadVisible" id="signature" width="100%" height="180px" ref="signaturePad" :options="signOptions"/>

        <!-- <VueSignaturePad id="signature" width="100%" height="180px" ref="signaturePad" :options="options"
          :default-action="'draw'" />-->
        <!-- <div class="default-tip" v-if="!isStartSign">请在此处绘制签名，本签名为图片</div>-->
        <div class="buttons">
          <span class="iconfont icon-undo" @click="undo()"></span>
          <!-- <span class="iconfont icon-rollback center-img"  @click="rollBack()"></span>-->
          <span class="iconfont icon-clear"  @click="clearSign()"></span>

          <!--<img src="@/assets/images/alldd.png"  alt="">
          <img src="@/assets/images/alldd.png"  class="center-img" alt="">
          <img src="@/assets/images/avatar.png"  alt="">-->
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { Toast } from "vant";
export default{
  props:{
    isSignaturePadVisible:{
      type:Boolean
    },
    signOptions:{
      type:Object,
      required: true
    }
  },
  data(){
    return {
      pointData: [],
      options: {
        penColor: "#000",
        backgroundColor: '#ddd',
        onBegin() {
          this.pointData = this.toData() || []
        }
      },
    }
  },
  methods:{

    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    //回滚
    rollBack() {
      let data = this.$refs.signaturePad.toData();
      console.log(data);
      if ((data && data.length) < this.pointData.length) {
        data.push(this.pointData[data.length])
      }
      this.$refs.signaturePad.fromData(data, { clear: false })
    },
    //清空
    clearSign() {
      this.$refs.signaturePad.clearSignature();
    },

    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (isEmpty) {
        Toast('请签名后再生成签字图片');
        return;
      }
      if(isEmpty == false) this.$emit('saveSignature', data);
    },
  },
}
</script>
<style scoped lang="scss">
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
  z-index: 99;
}

.sign-box {
  position: fixed;
  top: 0;
  height: 100vh;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
}

.sign-content {
  background: white;
  border-radius: 1.125rem 1.125rem 0 0;
  padding: .9375rem;
  width: 100%;
  position: relative;

  .default-tip {
    position: absolute;
    top: 8rem;
    width: 100%;
    text-align: center;
    color: #666666;
    font-size: .9375rem;
  }

  .title-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: .9375rem;
  }

  .cancel-p {
    color: #999999;
    font-size: .875rem;
    line-height: 1.25rem;
  }

  .confirm-p {
    color: #2288FF;
    font-size: .875rem;
    line-height: 1.25rem;
  }

  h1 {
    color: #333333;
    font-size: 1rem;
    line-height: 1.375rem;
  }
}


.buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 3rem;
  width: 12.2188rem;
  background: #F5F5F5;
  margin: .9375rem auto 0;
  border-radius: .5rem;

  .iconfont
  {
    font-size: 1.3438rem;
    margin: 0 1rem;
  }

  img {
    height: 1.3438rem;
    width: 1.3438rem;

    &.center-img {
      margin: 0 2rem;
    }
  }
}
</style>
